import { takeLatest } from 'redux-saga/effects';
import { LOCKED_ACCOUNTS_REFRESH_REQUEST } from '../../../../actionTypes';
import lockedAccountRefresh from './lockedAccountRefresh';

export default function* userRootSaga() {
  yield takeLatest([LOCKED_ACCOUNTS_REFRESH_REQUEST], lockedAccountRefresh);
}
